<template>
  <AuthLayout
    mode="register"
    sidebar-title="Thank you for registering"
    sidebar-text="Your application is being reviewed by our team."
    :support-phone="supportPhone"
    :progress-steps="practiceSteps"
    :progress-current-step="4"
    :title="classic ? 'Your Application approval.' : 'Application submitted'"
    :subtitle="classic ? 'Step 4. Application approval.' : 'We will review your application shortly.'"
    :card="false"
    :classic="classic"
    classic-register-url=""
  >
    <template v-if="classic" #classic-title>
      Your <span class="classic-auth__accent">Application</span> approval.
    </template>
    <template v-if="classic" #classic-subtitle>
      <span class="classic-auth__accent">Step 4.</span> Application approval.
    </template>

    <div class="auth-register__approval">
      <AuthIcon v-if="!classic" name="check" class="auth-register__approval-icon" />
      <p class="auth-register__verify-text">
        {{ classic
          ? 'You will receive email notification when your application is approved. Please allow 24 hours for application approval.'
          : 'Thank you for registering with RemoniHealth. Your application is being reviewed.'
        }}
      </p>
    </div>
  </AuthLayout>
</template>

<script setup>
import AuthLayout from '../../shared/components/AuthLayout.vue'
import AuthIcon from '../../shared/components/AuthIcon.vue'
import { PRACTICE_STEPS } from '../constants/steps.js'

defineProps({
  supportPhone: { type: String, default: '815-908-2020' },
  classic:      { type: Boolean, default: false },
})

const practiceSteps = PRACTICE_STEPS
</script>
